class GroupFormatter {

    groupFormat(data) {
        if (!data) return null;

        return {
            id: data.id ?? null,
            name: data.name == null ? "Aucune donnée" : data.name,
            clientId: data.clientId ?? null,
        };
    }

    groupsFormat(data) {
        if (!Array.isArray(data)) return [];

        return data
            .map(group => this.groupFormat(group))
            .filter(Boolean);
    }
}

export default new GroupFormatter();